import { ODataSelect } from "@iconics/core";

export class Ontology extends ODataSelect
{
    public Name = "";
    public DisplayName = "";
    public Description = "";
    public IsEnabled = "";
    public Id = "";
    public ["@odata.etag"] = "";

    override toSelect(): string
    {
        return ''
    }
}

export class OntologyNode extends ODataSelect
{
    public Name = "";
    public IsEnabled = "";
    public DisplayName = "";
    public IsRequired = "";
    public Id = "";
    public IsRecursive = "";
    public Parent_ID = "";
    public ["@odata.etag"] = "";

    override toSelect(): string
    {
        return ''
    }
}
